import { cn } from '@buakei/ui';

type BrandProps = {
  /** `navy` for light surfaces; `white` for navy surfaces. */
  tone?: 'navy' | 'white';
  showWordmark?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
};

const markSize = { sm: 'size-7', md: 'size-9', lg: 'size-14' } as const;
const textSize = { sm: 'text-lg', md: 'text-xl', lg: 'text-4xl' } as const;

/**
 * Buakei AI lockup: owner-supplied vector mark + live-text wordmark (heavy "Buakei", light "AI"),
 * matching the supplied logo while staying crisp and lightweight (ADR-005).
 */
export function Brand({ tone = 'navy', showWordmark = true, className, size = 'md' }: BrandProps) {
  const textColour = tone === 'navy' ? 'text-navy-900' : 'text-white';
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <img
        src={`/brand/mark-${tone}.svg`}
        alt={showWordmark ? '' : 'Buakei AI'}
        className={cn(markSize[size], 'object-contain')}
        width={56}
        height={56}
        decoding="async"
      />
      {showWordmark ? (
        <span className={cn('leading-none tracking-tight', textSize[size], textColour)}>
          <span className="font-extrabold">Buakei</span>
          <span className="sr-only"> </span>
          <span className="font-extralight">AI</span>
        </span>
      ) : null}
    </span>
  );
}
